module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-10.48fc3d31.png";